module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_8.976d1daf.png";